export const countries = [
  { value: 'AND', label: 'Andorra' },
  { value: 'ARG', label: 'Argentina' },
  { value: 'AUS', label: 'Australia' },
  { value: 'AUT', label: 'Austria' },
  { value: 'BEL', label: 'Belgium' },
  { value: 'BWA', label: 'Botswana' },
  { value: 'BVT', label: 'Bouvet Island' },
  { value: 'BRA', label: 'Brazil' },
  { value: 'BRN', label: 'Brunei' },
  { value: 'BGR', label: 'Bulgaria' },
  { value: 'CAN', label: 'Canada' },
  { value: 'CHN', label: 'China' },
  { value: 'CXR', label: 'Christmas Island' },
  { value: 'CCK', label: 'Cocos Islands' },
  { value: 'COL', label: 'Colombia' },
  { value: 'COK', label: 'Cook Islands' },
  { value: 'CZE', label: 'Czech Republic' },
  { value: 'DNK', label: 'Denmark' },
  { value: 'FRO', label: 'Faroe Islands' },
  { value: 'FIN', label: 'Finland' },
  { value: 'FRA', label: 'France' },
  { value: 'GUF', label: 'French Guiana' },
  { value: 'ATF', label: 'French Southern Territories' },
  { value: 'DEU', label: 'Germany' },
  { value: 'GRC', label: 'Greece' },
  { value: 'GRL', label: 'Greenland' },
  { value: 'GLP', label: 'Guadeloupe' },
  { value: 'HMD', label: 'Heard Island and McDonald Islands' },
  { value: 'HKG', label: 'Hong Kong' },
  { value: 'HUN', label: 'Hungary' },
  { value: 'ISL', label: 'Iceland' },
  { value: 'IND', label: 'India' },
  { value: 'IDN', label: 'Indonesia' },
  { value: 'IRN', label: 'Iran' },
  { value: 'IRL', label: 'Ireland' },
  { value: 'ISR', label: 'Israel' },
  { value: 'ITA', label: 'Italy' },
  { value: 'JPN', label: 'Japan' },
  { value: 'KAZ', label: 'Kazakhstan' },
  { value: 'KIR', label: 'Kiribati' },
  { value: 'LIE', label: 'Liechtenstein' },
  { value: 'LUX', label: 'Luxembourg' },
  { value: 'MYS', label: 'Malaysia' },
  { value: 'MTQ', label: 'Martinique' },
  { value: 'MUS', label: 'Mauritius' },
  { value: 'MYT', label: 'Mayotte' },
  { value: 'MEX', label: 'Mexico' },
  { value: 'MCO', label: 'Monaco' },
  { value: 'NRU', label: 'Nauru' },
  { value: 'NPL', label: 'Nepal' },
  { value: 'NLD', label: 'Netherlands' },
  { value: 'NZL', label: 'New Zealand' },
  { value: 'NIU', label: 'Niue' },
  { value: 'NFK', label: 'Norfolk Island' },
  { value: 'NOR', label: 'Norway' },
  { value: 'OMN', label: 'Oman' },
  { value: 'PAK', label: 'Pakistan' },
  { value: 'PSE', label: 'Palestinian Territory' },
  { value: 'PHL', label: 'Philippines' },
  { value: 'PCN', label: 'Pitcairn' },
  { value: 'POL', label: 'Poland' },
  { value: 'PRT', label: 'Portugal' },
  { value: 'QAT', label: 'Qatar' },
  { value: 'REU', label: 'Reunion' },
  { value: 'ROU', label: 'Romania' },
  { value: 'RUS', label: 'Russia' },
  { value: 'SPM', label: 'Saint Pierre and Miquelon' },
  { value: 'SMR', label: 'San Marino' },
  { value: 'SAU', label: 'Saudi Arabia' },
  { value: 'SGP', label: 'Singapore' },
  { value: 'SVN', label: 'Slovenia' },
  { value: 'ZAF', label: 'South Africa' },
  { value: 'SGS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'KOR', label: 'South Korea' },
  { value: 'ESP', label: 'Spain' },
  { value: 'LKA', label: 'Sri Lanka' },
  { value: 'SJM', label: 'Svalbard and Jan Mayen' },
  { value: 'SWE', label: 'Sweden' },
  { value: 'CHE', label: 'Switzerland' },
  { value: 'TWN', label: 'Taiwan' },
  { value: 'THA', label: 'Thailand' },
  { value: 'TKL', label: 'Tokelau' },
  { value: 'TTO', label: 'Trinidad and Tobago' },
  { value: 'TUR', label: 'Turkey' },
  { value: 'TUV', label: 'Tuvalu' },
  {
    value: 'USA',
    label: 'United States',
  },
  { value: 'GBR', label: 'United Kingdom' },
  { value: 'VAT', label: 'Vatican' },
  { value: 'VEN', label: 'Venezuela' },
];
